import { Box, IconButton, Tooltip, Button, Typography, type Theme, useMediaQuery } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, TitlePortal, useLogout, useTranslate } from 'react-admin';

import { AdminUserMenu } from './AdminUserMenu';
import { getAdminChromeColor, getAdminEnvironmentLabel } from './adminEnvironment';
import { ExamNameToggle } from './ExamNameToggle';

export function AppTopBar() {
    const logout = useLogout();
    const translate = useTranslate();
    const logoutLabel = translate('ra.auth.logout', { _: 'Logout' });
    const isLargeEnough = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'));
    const chromeColor = getAdminChromeColor();
    const environmentLabel = getAdminEnvironmentLabel();
    const repeatedEnvironmentLabel = Array.from({ length: 6 }, () => environmentLabel).join('  ');

    return (
        <AppBar
            userMenu={<AdminUserMenu />}
            sx={{
                backgroundColor: chromeColor,
                color: '#ffffff',
                '& .RaAppBar-toolbar, & .MuiToolbar-root': {
                    minHeight: 44,
                    px: 1.5,
                },
                '& .MuiTypography-root, & .MuiButton-root, & .MuiIconButton-root, & .MuiSvgIcon-root': {
                    color: '#ffffff',
                },
            }}
        >
            <TitlePortal />
            <Box
                sx={{
                    flex: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    px: 1.5,
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '0.76rem',
                        fontWeight: 800,
                        letterSpacing: '0.22em',
                        textTransform: 'uppercase',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'clip',
                    }}
                >
                    {repeatedEnvironmentLabel}
                </Typography>
            </Box>
            <ExamNameToggle />
            {isLargeEnough ? (
                <Button
                    color="inherit"
                    startIcon={<LogoutIcon />}
                    onClick={() => logout()}
                    sx={{ ml: 0.5, color: '#ffffff' }}
                    aria-label={logoutLabel}
                    variant="text"
                >
                    {logoutLabel}
                </Button>
            ) : (
                <Tooltip title={logoutLabel}>
                    <IconButton
                        color="inherit"
                        onClick={() => logout()}
                        sx={{ ml: 0.5, color: '#ffffff' }}
                        aria-label={logoutLabel}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            )}
        </AppBar>
    );
}